import Image from "next/image";
import React from "react";
import DefaultCurrencyFormat from "../../DefaultCurrencyFormat";
import Remote from "../../LoaderRemote";
import { useTranslation } from "../../../context/TranslationContext";

const CustomerInformationArea = ({ passengerInformationData }) => {
  const {
    reservationNo,
    reservationDate,
    ReservationStatus3Text,
    reservationCustomerName,
    reservationDate1,
    reservationDate2,
    reservationtionPrice,
  } = useTranslation();
  return (
    <div className="ct:w-[380px] w-full 2xl:pr-14 xl:pr-6 xl:border-r-2 border-[#EDF6FB] xl:order-1 order-2">
      <div className="relative  xl:w-[264px] w-full h-[173px] rounded mb-4">
        <Image
          src={passengerInformationData.reservation.resim}
          layout="fill"
          loader={Remote}
          alt={passengerInformationData.reservation.title}
          objectFit={"cover"}
        />
      </div>
      <div className="flex flex-col items-start mb-3">
        <div className="flex items-center mr-9">
          <span className="font-semibold text-13 leading-[18px] text-dark ">
            {reservationNo} :
          </span>
          <span className="font-semibold text-13 leading-[18px] text-dark border-b">
            {passengerInformationData.reservation.id}
          </span>
        </div>
        <div className="font-semibold text-13 text-[#A1B2B8] leading-[18px]">
          {reservationDate} :{" "}
          {passengerInformationData.reservation.islem_tarihi}
        </div>
      </div>
      <div className="flex items-center xl:justify-start justify-between mb-4">
        <span className="text-[23px] font-semibold text-dark leading-[31px] mr-3">
          {passengerInformationData.reservation.baslik}
        </span>
        <div className="flex items-center py-[6px] px-[10px] rounded bg-[#00BBC0] mr-3">
          <span className="font-bold text-[10px] leading-[14px]  text-white">
            {ReservationStatus3Text}
          </span>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div className="flex flex-col">
          <div className="flex items-center">
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]">
              {reservationCustomerName}
            </span>
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark">
              {passengerInformationData.reservation.musteri}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]">
              {reservationDate1}
            </span>
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark">
              {passengerInformationData.reservation.tarih}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]">
              {reservationDate2}
            </span>
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark">
              {passengerInformationData.reservation.tarih2}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]">
              {reservationtionPrice}
            </span>
            <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark">
              <DefaultCurrencyFormat
                value={passengerInformationData.reservation.tutar}
                Symbol={passengerInformationData.reservation.Symbol}
              ></DefaultCurrencyFormat>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInformationArea;
